import { LogoutOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useAppState } from '../../state/AppState';
import HomeButton from '../common/HomeButton';
import UserAvatar from '../common/UserAvatar';

const Profile = () => {
  const { user, logOut } = useAppState();
  const history = useHistory();

  return (
    <div>
      {user && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: 600, paddingTop: 100 }}>
            <div style={{ marginBottom: 100 }}>
              <div
                style={{
                  backgroundColor: 'white',
                  display: 'inline-block',
                  padding: '1em 3em',
                  borderRadius: '16px 16px 0 0',
                }}>
                <h1 style={{ marginBottom: 0 }}>Profile</h1>
              </div>
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '3em',
                  borderRadius: '0 16px 16px',
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                }}>
                <UserAvatar size={120} />
                <div>
                  <div style={{ display: 'flex', color: 'black', fontSize: 24 }}>
                    {user?.displayName || 'Anonymous User'}
                  </div>
                </div>
                <Button
                  style={{ display: 'flex' }}
                  onClick={async () => {
                    await logOut();
                    history.push('/');
                  }}>
                  <LogoutOutlined style={{ marginRight: 16 }} />
                  Sign out
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      <HomeButton />
    </div>
  );
};

export default Profile;
